<template>
  <div style="float:right">
    <span v-if="$vuetify.breakpoint.smAndUp" class="caption">Download as </span>
    <v-btn small class="caption mr-2" @click="download('PDF')">PDF</v-btn>
    <v-btn small class="caption" @click="download('CSV')">CSV</v-btn>
  </div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var JsPDF = require('jspdf')
require('jspdf-autotable')

export default {
  props: ['headers', 'items', 'title', 'subtitle', 'tablefooter', 'letterHead', 'landscape', 'fontsize', 'cellpadding', 'legend'],
  methods: {
    download (type) {
      /* NOTE:
      Making use of PDF plug-in to generate CSV file as well
      */
      // construnct cols from passed table heading
      var cols = []
      var colStyle = {}
      var colFormat = []
      this.headers.forEach(rec => {
        if (rec.text) {
          // column title and value key
          cols.push({title: rec.text, dataKey: rec.value})
          // column style if any
          if (rec.align || rec.columnWidth) {
            colStyle[rec.value] = {}
            if (rec.align) {
              colStyle[rec.value].halign = rec.align
            }
            if (rec.columnWidth) {
              colStyle[rec.value].cellWidth = rec.columnWidth
            }
          }
          // column format if any
          colFormat[rec.value] = rec.format
        }
      })
      // local copy for later use
      var locItems = this.items

      // pdf
      var doc = null
      if (this.landscape) {
        doc = new JsPDF('landscape')
      } else {
        doc = new JsPDF()
      }

      var totalPagesExp = '{total_pages_count_string}'
      var pageContent = (data) => {
        // HEADER
        doc.setFontSize(20)
        doc.setFontStyle('normal')
        // a. community details
        if (!this.letterHead) {
          doc.setTextColor(139, 195, 74)
          doc.text(config.VENDOR_NAME, data.settings.margin.left, 15)
          doc.setDrawColor(241, 241, 241)
          doc.line(0, 20, doc.internal.pageSize.width || doc.internal.pageSize.getWidth(), 20)
        }
        doc.setTextColor(40)

        // b. report heading
        doc.setFontSize(16)
        doc.text(this.title, data.settings.margin.left, 30)
        // c. report subheading
        if (this.subtitle) {
          doc.setFontSize(10)
          doc.text(this.subtitle, data.settings.margin.left, 35)
        }

        // FOOTER
        var str = 'Page ' + data.pageCount
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(10)
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight()
        doc.text(str + '\nDownloaded By ' + handy.startWithUpper(config.USER_NAME) + ' On ' + handy.formatDate(new Date()) + ' ' + handy.getTime12Hrs(new Date()), data.settings.margin.left, pageHeight - 10)

        // app logo
        var image = new Image()
        image.onload = function () {
          var canvas = document.createElement('canvas')
          canvas.width = this.naturalWidth
          canvas.height = this.naturalHeight

          //next three lines for white background in case png has a transparent background
          var ctx = canvas.getContext('2d')
          ctx.fillStyle = '#fff'  /// set white fill style
          ctx.fillRect(0, 0, canvas.width, canvas.height)

          canvas.getContext('2d').drawImage(this, 0, 0)
          doc.addImage(canvas.toDataURL('image/jpeg'), 10, 10, 128, 128)
        }

        image.src = 'sv_full.png'
        // last row of CSV which was missed in didDrawCell
        if (csvCont.length <= locItems.length) {
          csvCont.push(csvLine.join())
        }
      }

      // FULL CONTENT
      var csvHeader = ''
      var csvCont = []
      var csvLine = []
      var prevProcIdx = -1
      doc.autoTable(cols, this.items, {
        theme: 'grid',
        didDrawPage: pageContent,
        margin: {top: this.subtitle ? 40 : 35},
        columnStyles: colStyle,
        styles: {
          fontSize: this.fontsize || 10,
          cellPadding: this.cellpadding || 2,
          overflow: 'linebreak'
        },
        didParseCell: function (HookData) {
          if (HookData.cell.raw === null) {
            // special handling for nulls
            HookData.cell.text[0] = ''
          } else if (colFormat[HookData.column.dataKey]) { // formatting
            // format as requested
            HookData.cell.text[0] = handy[colFormat[data.column.dataKey]](cell.raw)
          } else if (HookData.column.dataKey.indexOf('_list') < 0 && HookData.cell.section === 'body' && (HookData.column.dataKey.indexOf('_dt') >= 0 || HookData.column.dataKey.indexOf('_date') >= 0 || HookData.column.dataKey.indexOf('_birth') >=0 || HookData.column.dataKey.indexOf('_joining') >=0) || HookData.column.dataKey.indexOf('releived') >=0) {
            // special handling for dates
            HookData.cell.text[0] = HookData.cell.raw ? handy.formatDate(HookData.cell.raw) : ''
          } else if (HookData.cell.section === 'body' && (HookData.column.dataKey.indexOf('_time') >= 0 || HookData.column.dataKey.indexOf('_in') >= 0 || HookData.column.dataKey.indexOf('_out') >= 0 || HookData.column.dataKey.indexOf('_on') >= 0)) {
            // special handling for date time
            HookData.cell.text[0]  = HookData.cell.raw ? handy.formatDisplayDateTime(HookData.cell.raw): ''
          } else if (HookData.column.raw.title.indexOf('?') >= 0) {
            // special handling boolean
            if (HookData.cell.raw === 0 || HookData.cell.raw === 1 || typeof HookData.cell.raw === 'boolean') {
              HookData.cell.text[0] = (!HookData.cell.raw ? 'No' : 'Yes')
            }
          }
          // for csv
          if (HookData.section === 'body' && HookData.row.index > prevProcIdx) {
            csvCont[HookData.row.index] = csvLine.join()
            csvLine = []
            prevProcIdx++
          }
          csvLine.push('"' + (HookData.cell.text.length > 1 ? HookData.cell.raw : HookData.cell.text[0]) + '"')
        }
      })

      // table legend
      if (this.legend) {
        doc.setFontSize(8)
        doc.text(this.legend, 15, doc.autoTable.previous.finalY + 4)
      }

      // table footer
      if (this.tablefooter) {
        doc.setFontSize(12)
        doc.text(this.tablefooter, 15, doc.autoTable.previous.finalY + 10)
      }

      // page footer
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }

      // download
      if (type === 'PDF') {
        doc.save(this.title + '.pdf')
      } else { // csv
        // table footer if requested
        csvCont = csvCont.join('\n')
        if (this.tablefooter) {
          csvCont  += '\n' + this.tablefooter
        }
        var blob = new Blob([csvCont])
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob, {type: 'text/plain'})
        link.setAttribute('download', this.title + (this.subtitle ? ' ' + this.subtitle : '') + '.csv')
        document.body.appendChild(link) // Required for FF
        link.click()
        document.body.removeChild(link)
      }
    }
  }
}
</script>
